export default __webpack_public_path__ + "static/media/hands.2230b443.svg";